/* eslint-disable prettier/prettier */
import en_US from 'tea-component/es/i18n/locale/en_US';
import zh_CN from 'tea-component/es/i18n/locale/zh_CN';
import { LANGUAGE_CN } from '@/pages/home/_config/config';
import { setIntl } from "@@/plugin-locale/localeExports";
import { event, LANG_CHANGE_EVENT } from "@@/plugin-locale/locale";

/**
 * 获取指定系统语言环境 对应的 tea组件ConfigProvider配置 需要的语言环境配置数据
 * @param locale 系统语言环境locale
 * @returns tea组件ConfigProvider配置 需要的语言环境配置数据
 */
export const getTeaLocale = (locale: string): any =>
  locale === 'en-US' ? en_US : zh_CN;

/**
 * 获取 指定当前系统语言环境,指定数据对象的 某个字段的值(根据当前系统语言环境,自适应从不同字段(中英文字段差异)取值)
 * @param locale 系统语言环境
 * @param item 数据对象
 * @param enKey 英文内容的字段
 * @param cnKey 中文内容的字段
 * @returns 当前系统语言环境下的 字段内容
 */
export const getLocalText: (
  locale: string,
  item: any,
  enKey: string,
  cnKey: string,
) => string = (locale, item, enKey, cnKey) => {
  if (locale === LANGUAGE_CN) {
    return item?.[cnKey] || item?.[enKey] || '';
  }
  return item?.[enKey] || item?.[cnKey] || '';
};

/**
 * DataBrain 系统页面作为iframe嵌入时, 当父级页面和iframe同源时, 根据父级页面中英文状态, iframe页面内部直接使用setLocale方法切换中英文时, 无法转换成功 (setLocale内部if判断未通过)
 * 所以将 setLocale内部的if判断逻辑去掉后, 重新封装一个方法
 * @param lang 转换的语言
 * @param realReload 是否强制刷新页面
 */
export const setIframeLocale = (lang: string, realReload = true) => {
  if (navigator.cookieEnabled && typeof window.localStorage !== 'undefined') {
    window.localStorage.setItem('umi_locale', lang || '');
  }
  setIntl(lang); // 只执行setIntl不能改变页面中英文
  if (realReload) {
    window.location.reload(); // 直接强制刷新页面
  } else {
    // 触发页面中英文转换
    event.emit(LANG_CHANGE_EVENT, lang);
    // chrome 不支持这个事件。所以人肉触发一下
    if (window.dispatchEvent) {
      const event = new Event('languagechange');
      window.dispatchEvent(event);
    }
  }
};